import { useState } from 'react';

export const useToggle = () => {
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleExpanded = () => {
		setIsExpanded((prev) => !prev);
	};

	return {
		isExpanded,
		toggleExpanded,
	};
};
